import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import BarTop from "../BarTop/BarTop";
import styles from "./AuthenticatedLayout.module.scss";
import TrustedFeatures from "../../TrustedFeatures/TrustedFeatures";
import Newsletter from "../../Newsletter/Newsletter";
import { FaWhatsapp } from "react-icons/fa";

const LayoutChromeContext = createContext(null);

const AuthenticatedLayout = ({ children, withSearch = false, events = [] }) => {
  const parentChrome = useContext(LayoutChromeContext);
  const [nestedChrome, setNestedChrome] = useState({
    withSearch: false,
    events: [],
  });

  const updateNestedChrome = useCallback((nextChrome) => {
    setNestedChrome({
      withSearch: Boolean(nextChrome?.withSearch),
      events: nextChrome?.events ?? [],
    });
  }, []);

  const chromeApi = useMemo(
    () => ({
      update: updateNestedChrome,
    }),
    [updateNestedChrome],
  );

  useEffect(() => {
    if (!parentChrome) return undefined;

    parentChrome.update({ withSearch, events });

    return () => {
      parentChrome.update({ withSearch: false, events: [] });
    };
  }, [parentChrome, withSearch, events]);

  if (parentChrome) {
    return children;
  }

  const showSearch = withSearch || nestedChrome.withSearch;
  const searchEvents = events.length > 0 ? events : nestedChrome.events;
  const waLink = `https://wa.me/5491126701220?text=Hola%20ticketgo`;

  return (
    <LayoutChromeContext.Provider value={chromeApi}>
      <section className={styles.containerLayout}>
        <BarTop />
        <Navbar withSearch={showSearch} events={searchEvents} />

        <main className={`container-fluid p-0 ${styles.customContainer}`}>
          {children}
        </main>

        <section
          className={`container py-3 my-3 ${styles.trustSection}`}
          aria-labelledby="trust"
        >
          <h2 id="trust" className="visually-hidden">
            Beneficios y confianza
          </h2>
          <TrustedFeatures />
        </section>

        <div className={styles.borderLine}></div>

        <section
          className={`container py-3 ${styles.newsletterSection}`}
          aria-labelledby="newsletter"
        >
          <h2 id="newsletter" className="visually-hidden">
            Suscripción al newsletter
          </h2>
          <Newsletter />
        </section>

        <Footer />

        <a
          href={waLink}
          className={styles.whatsappFloat}
          target="_blank"
          rel="noreferrer"
          aria-label="Contactar por WhatsApp"
          title="WhatsApp"
        >
          <FaWhatsapp />
        </a>
      </section>
    </LayoutChromeContext.Provider>
  );
};

export default AuthenticatedLayout;
